var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container mt-1"},[(_vm.header)?_c('div',{staticClass:"card-header row"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }